import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { Rule } from "@rumble-it/common-lib/types/models/Rule.interface";
import { EyeOutlined } from "@ant-design/icons";

export const ruleColumns: TableColumnsType<Rule> = [
  {
    title: "Naam",
    dataIndex: "name",
    key: "name",
    render: (text: string, record: Rule) => (
      <Link to={`/rules/${record.id}`}>{text}</Link>
    ),
  },
  {
    title: "Omschrijving",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Conditie",
    dataIndex: "conditionMatcher",
    key: "conditionMatcher",
    render: (v: string) =>
      v === "all" ? "Alle condities" : "Een van de condities",
  },
  {
    title: "Event",
    dataIndex: "eventName",
    key: "eventName",
  },
  {
    title: "Stop Propagation",
    dataIndex: "stopPropagation",
    key: "stopPropagation",
    render: (v: boolean) => (v ? "Ja" : "Nee"),
  },
  {
    title: "Prioriteit",
    dataIndex: "priority",
    key: "priority",
  },
  {
    title: "Actief",
    dataIndex: "active",
    key: "active",
    render: (v: boolean) => (v ? "Ja" : "Nee"),
  },
  {
    title: "Acties",
    dataIndex: "actions",
    key: "actions",
    render: (_: any, record) => (
      <Link to={`/rules/${record.id}`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
